export enum ColumnsRootKey {
  Runs = 'runs',
  Reports = 'reports',
  WidgetChartsComparison = 'widgetChartsComparison',
  WidgetImageComparison = 'widgetImageComparison',
  MyRuns = 'myRuns',
  NoKey = 'undefined',
}
